import React from 'react';
import Layout from '../components/shared/Layout';
import MetaHead from '../components/shared/MetaHead';

const OmPage = () => {
  return (
    <Layout>
      <MetaHead title="Om Hansen-Byg - et totalenterprise firma" />

      <h1>Om Hansen-Byg</h1>
      <p>
        Hansen-Byg er et totalenterprise firma, der siden 2006 har udført alle
        former for murer, tømrer og malerarbejde.
      </p>
      <p>
        Vi udfører nybyg, renovering og ombygning i total- og hovedentreprise
        for både private og erhverv.
      </p>
      <p>
        Hansen-Byg er ejet af murermester Thomas Bruun Hansen. Et lokalt
        byggefirma med stor faglig viden og erfaring.
      </p>
    </Layout>
  );
};

export default OmPage;
